<template>
  <div class="tongji-detail-page">
    <div class="hero-card">
      <div class="hero-left">
        <div class="back-link" @click="goBack">返回分类页</div>
        <div class="hero-title">{{ category.name || '分类详情' }}</div>
        <div class="hero-desc">每条数据由名称和图片地址组成。点击卡片可修改名称和图片地址，新增时同样直接填写图片地址。</div>
      </div>
      <div class="hero-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">添加数据</el-button>
        <el-button icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
    </div>

    <div class="info-row">
      <div class="info-card preview-card">
        <div class="preview-image-wrap">
          <img v-if="category.img" :src="category.img" class="preview-image" />
          <div v-else class="preview-image empty-image">{{ getFirstChar(category.name) }}</div>
        </div>
        <div class="preview-meta">
          <div class="preview-name">{{ category.name || '未命名分类' }}</div>
          <div class="preview-id">分类 ID {{ category.id || 0 }}</div>
        </div>
      </div>
      <div class="info-card count-card">
        <div class="count-label">当前条数</div>
        <div class="count-value">{{ detailList.length }}</div>
      </div>
    </div>

    <div v-if="detailList.length" class="detail-grid" v-loading="loading">
      <div
        v-for="item in detailList"
        :key="item.id"
        class="detail-card"
        @click="openEditDialog(item)"
      >
        <div class="detail-image-wrap">
          <img v-if="item.img" :src="item.img" class="detail-image" />
          <div v-else class="detail-image empty-image small-empty">{{ getFirstChar(item.name) }}</div>
        </div>
        <div class="detail-body">
          <div class="detail-name">{{ item.name || '未命名' }}</div>
          <div class="detail-id">ID {{ item.id }}</div>
          <div class="detail-tip">点击修改名称和图片</div>
        </div>
      </div>
    </div>

    <div v-else-if="!loading" class="empty-box">
      当前分类还没有数据，点击上方“添加数据”开始录入
    </div>

    <el-dialog
      title="添加数据"
      :visible.sync="addDialogVisible"
      width="620px"
    >
      <el-form label-width="90px">
        <el-form-item label="名称">
          <el-input
            v-model="addForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片地址">
          <el-input
            v-model="addForm.img"
            type="textarea"
            :rows="4"
            placeholder="请输入图片地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitAddLoading" @click="submitAdd">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="修改数据"
      :visible.sync="editDialogVisible"
      width="620px"
    >
      <div class="dialog-name">当前 ID {{ editForm.id || 0 }}</div>
      <el-form label-width="90px">
        <el-form-item label="名称">
          <el-input
            v-model="editForm.name"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片地址">
          <el-input
            v-model="editForm.img"
            type="textarea"
            :rows="4"
            placeholder="请输入图片地址"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="danger" plain :loading="deleteLoading" @click="submitDelete">删除</el-button>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitEditLoading" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      apiBase: 'https://tossp.yoooooo.com/index.php/index/tongji',
      loading: false,
      submitAddLoading: false,
      submitEditLoading: false,
      deleteLoading: false,
      categoryId: 0,
      category: {},
      detailList: [],
      addDialogVisible: false,
      editDialogVisible: false,
      addForm: {
        category_id: 0,
        name: '',
        img: ''
      },
      editForm: {
        id: 0,
        name: '',
        img: ''
      }
    }
  },
  created() {
    this.categoryId = Number(this.$route.query.category_id || 0)
    if (!this.categoryId) {
      this.$message.error('缺少分类参数')
      this.goBack()
      return
    }
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await axios.post(this.apiBase + '/getTongjiPerceptionDetail', {
          category_id: this.categoryId
        })
        if (res.data.code === 200) {
          this.category = res.data.category || {}
          this.detailList = res.data.data || []
        } else {
          this.$message.error(res.data.msg || '加载失败')
        }
      } catch (e) {
        this.$message.error('加载失败')
      }
      this.loading = false
    },
    goBack() {
      this.$router.push({ name: 'TongjiPerception' })
    },
    openAddDialog() {
      this.addForm = {
        category_id: this.categoryId,
        name: '',
        img: ''
      }
      this.addDialogVisible = true
    },
    async submitAdd() {
      if (!this.addForm.name) {
        this.$message.error('请输入名称')
        return
      }
      this.submitAddLoading = true
      try {
        const res = await axios.post(this.apiBase + '/addTongjiPerceptionDetail', this.addForm)
        if (res.data.code === 200) {
          this.$message.success('添加成功')
          this.addDialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.submitAddLoading = false
    },
    openEditDialog(item) {
      this.editForm = {
        id: item.id,
        name: item.name || '',
        img: item.img || ''
      }
      this.editDialogVisible = true
    },
    async submitEdit() {
      if (!this.editForm.name) {
        this.$message.error('请输入名称')
        return
      }
      this.submitEditLoading = true
      try {
        const res = await axios.post(this.apiBase + '/updateTongjiPerceptionDetail', this.editForm)
        if (res.data.code === 200) {
          this.$message.success('修改成功')
          this.editDialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败')
      }
      this.submitEditLoading = false
    },
    submitDelete() {
      const _this = this
      this.$confirm('删除后不可恢复，是否继续？', '提示', {
        type: 'warning'
      }).then(async function() {
        _this.deleteLoading = true
        try {
          const res = await axios.post(_this.apiBase + '/deleteTongjiPerceptionDetail', {
            id: _this.editForm.id
          })
          if (res.data.code === 200) {
            _this.$message.success('删除成功')
            _this.editDialogVisible = false
            _this.loadData()
          } else {
            _this.$message.error(res.data.msg || '删除失败')
          }
        } catch (e) {
          _this.$message.error('删除失败')
        }
        _this.deleteLoading = false
      }).catch(function() {})
    },
    getFirstChar(name) {
      if (!name) {
        return '图'
      }
      return String(name).slice(0, 1)
    }
  }
}
</script>

<style scoped>
.tongji-detail-page {
  min-height: 100vh;
  padding: 24px;
  background: #f4f7fb;
  box-sizing: border-box;
}

.tongji-detail-page,
.tongji-detail-page * {
  box-sizing: border-box;
}

.hero-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  margin-bottom: 20px;
  border-radius: 20px;
  background: linear-gradient(135deg, #16a085 0%, #4776e6 100%);
  color: #fff;
  box-shadow: 0 16px 36px rgba(47, 96, 255, 0.2);
}

.back-link {
  display: inline-block;
  margin-bottom: 10px;
  font-size: 13px;
  cursor: pointer;
  opacity: 0.9;
}

.hero-title {
  font-size: 24px;
  font-weight: 700;
}

.hero-desc {
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.92;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px 20px;
}

.info-card {
  margin: 0 8px 16px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(31, 45, 61, 0.06);
}

.preview-card {
  display: flex;
  align-items: center;
  width: calc(75% - 16px);
  min-width: 320px;
  padding: 18px;
}

.preview-image-wrap {
  width: 96px;
  height: 96px;
  overflow: hidden;
  border-radius: 16px;
  background: #edf2ff;
  flex-shrink: 0;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.empty-image {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4862ff;
  font-weight: 700;
}

.preview-meta {
  margin-left: 18px;
}

.preview-name {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
}

.preview-id {
  margin-top: 10px;
  color: #7d8ba3;
  font-size: 14px;
}

.count-card {
  width: calc(25% - 16px);
  min-width: 220px;
  padding: 20px 22px;
}

.count-label {
  color: #8a94a6;
  font-size: 14px;
}

.count-value {
  margin-top: 10px;
  color: #1f2d3d;
  font-size: 28px;
  font-weight: 700;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 18px;
}

.detail-card {
  overflow: hidden;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(31, 45, 61, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.detail-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 34px rgba(31, 45, 61, 0.12);
}

.detail-image-wrap {
  height: 170px;
  background: #eef2ff;
}

.detail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.small-empty {
  font-size: 46px;
}

.detail-body {
  padding: 16px;
}

.detail-name {
  color: #1f2d3d;
  font-size: 16px;
  font-weight: 700;
  word-break: break-all;
}

.detail-id {
  margin-top: 10px;
  color: #245bdb;
  font-size: 12px;
  font-weight: 700;
}

.detail-tip {
  margin-top: 8px;
  color: #8a94a6;
  font-size: 13px;
}

.empty-box {
  padding: 72px 20px;
  border-radius: 18px;
  background: #fff;
  text-align: center;
  color: #8a94a6;
  font-size: 14px;
}

.dialog-name {
  margin-bottom: 18px;
  color: #1f2d3d;
  font-size: 16px;
  font-weight: 600;
}

@media screen and (max-width: 768px) {
  .tongji-detail-page {
    padding: 16px;
  }

  .hero-card {
    display: block;
  }

  .hero-actions {
    margin-top: 16px;
  }

  .preview-card,
  .count-card {
    width: calc(100% - 16px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/aatongjiPerceptionDetail.vue